import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=4842cf4c&scoped=true"
var script = {}
import style0 from "./Spinner.vue?vue&type=style&index=0&id=4842cf4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4842cf4c",
  null
  
)

export default component.exports